import { ref, computed } from "#imports";
import { PopperStrategy, UiPlacement } from "./PopperPlacement.js";
import { autoPlacement, autoUpdate, hide, offset, shift, arrow, useFloating, flip } from "@floating-ui/vue";
function getMiddleware(options) {
  const middleware = [];
  const padding = options.offset || 16;
  if (options.auto) {
    middleware.push(autoPlacement({ padding }));
  }
  middleware.push(flip());
  middleware.push(
    shift({
      crossAxis: true,
      padding: options.offsetBorder
    })
  );
  if (options.arrow) {
    middleware.push(arrow({ element: options.arrow, padding: 4 }));
  }
  middleware.push(offset(padding));
  return middleware;
}
export function usePopper(reference, floating, options = {}) {
  const placement = options.placement || ref(UiPlacement.BottomEnd);
  const { x, y, strategy, update, isPositioned, middlewareData } = useFloating(reference, floating, {
    placement,
    strategy: options.strategy || PopperStrategy.Absolute,
    middleware: [hide(), ...getMiddleware(options)],
    open: options.isOpen,
    whileElementsMounted: autoUpdate
  });
  const style = computed(() => {
    return {
      position: strategy.value,
      top: `${y.value || 0}px`,
      left: `${x.value || 0}px`,
      width: "max-content",
      visibility: options.hide && !isPositioned.value ? "hidden" : "visible"
    };
  });
  return {
    update,
    style,
    middlewareData
  };
}
export function useMousePopper(floating, point, options = {}) {
  const virtualEl = ref({
    getBoundingClientRect() {
      return {
        x: point.value.x,
        y: point.value.y,
        top: point.value.y,
        left: point.value.x,
        right: point.value.x,
        bottom: point.value.y,
        width: 0,
        height: 0
      };
    }
  });
  return usePopper(virtualEl, floating, options);
}
export function useOpenClosePopper(reference, floating, { emit, strategy, offset: offset2, offsetBorder, placement, arrow: arrow2, auto, isOpen = ref(false) }) {
  const close = () => {
    if (!isOpen.value) {
      return;
    }
    isOpen.value = false;
    emit("close:popper");
  };
  const open = () => {
    if (isOpen.value) {
      return;
    }
    isOpen.value = true;
    emit("open:popper");
  };
  return {
    open,
    close,
    isOpen,
    ...usePopper(reference, floating, { strategy, placement, offset: offset2, offsetBorder, arrow: arrow2, auto })
  };
}
